import { Link } from 'react-router-dom';

const partnerOrgs = [
  {
    id: 1,
    name: '대한문신사중앙회',
    logo: 'https://public.readdy.ai/ai/img_res/a805cbe8-2778-43ef-a335-0744e5a81652.png',
    desc: '대한문신사중앙회',
    url: 'https://www.ktf-i.or.kr/',
  },
  {
    id: 2,
    name: '국세청',
    logo: 'https://public.readdy.ai/ai/img_res/832d398e-af23-4f9b-b0ab-19d95616cbd4.png',
    desc: '국세청',
    url: 'https://www.nts.go.kr',
  },
  {
    id: 3,
    name: '보건복지부',
    logo: 'https://public.readdy.ai/ai/img_res/799e2aa8-abb5-4b3f-9fb6-e585299de7a7.png',
    desc: '보건복지부',
    url: 'https://www.mohw.go.kr',
  },
  {
    id: 4,
    name: '산업통상자원부',
    logo: 'https://public.readdy.ai/ai/img_res/65bc67b4-4657-4c29-b7fa-7e42f01fa652.png',
    desc: '산업통상자원부',
    url: 'https://www.motie.go.kr',
  },
  {
    id: 5,
    name: '소상공인연합회',
    logo: 'https://public.readdy.ai/ai/img_res/06b08bb6-e644-4ca6-8527-7a8e1512a428.png',
    desc: '소상공인연합회',
    url: 'https://www.kfme.or.kr',
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#F4F6FA] border-t border-gray-200">
      {/* 공식 협력기관 섹션 */}
      <div className="border-b border-gray-200/60">
        <div className="max-w-7xl mx-auto px-6 py-10">
          <div className="flex items-center justify-center gap-4 mb-8">
            <div className="h-px w-12 bg-gradient-to-r from-transparent to-gray-300" />
            <p className="text-gray-400 text-xs font-medium tracking-[0.2em] uppercase">Official Partners</p>
            <div className="h-px w-12 bg-gradient-to-l from-transparent to-gray-300" />
          </div>
          <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
            {partnerOrgs.map((org) => (
              <a
                key={org.id}
                href={org.url}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="group flex flex-col items-center gap-2 cursor-pointer"
                title={org.name}
              >
                <div className="w-20 h-12 md:w-24 md:h-14 flex items-center justify-center transition-all duration-300">
                  <img
                    src={org.logo}
                    alt={org.name}
                    className="max-w-full max-h-full object-contain grayscale opacity-50 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300"
                  />
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">
          <div className="md:col-span-1">
            <img
              src="https://public.readdy.ai/ai/img_res/7d6ce8a8-ae30-4065-ad4c-0a166a63deb4.png"
              alt="대한문신사중앙회 중구지부"
              className="h-12 w-auto object-contain mb-4"
            />
            <div className="flex items-center gap-2 mb-1">
              <div className="flex flex-col items-center justify-center border border-[#C9A84C] rounded-sm px-2 py-1 flex-shrink-0 bg-gradient-to-b from-[#C9A84C]/15 to-[#C9A84C]/5">
                <span className="text-[8.5px] font-black leading-none tracking-[0.15em] text-[#C9A84C]">사단</span>
                <span className="w-full h-px my-0.5 bg-[#C9A84C]/40" />
                <span className="text-[8.5px] font-black leading-none tracking-[0.15em] text-[#C9A84C]">법인</span>
              </div>
              <p className="text-[#1B3A6B] font-bold text-sm">대한문신사중앙회 중구지부</p>
            </div>
            <p className="text-gray-500 text-xs leading-relaxed mb-4">보건복지부 정식 인가<br />공식 교육 기관</p>
            <div className="flex items-center gap-2">
              <a href="https://instagram.com" target="_blank" rel="nofollow noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded-full border border-[#1B3A6B]/20 text-[#1B3A6B] cursor-pointer hover:bg-[#1B3A6B] hover:text-white transition-colors">
                <i className="ri-instagram-line text-sm" />
              </a>
              <a href="https://pf.kakao.com" target="_blank" rel="nofollow noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded-full border border-[#1B3A6B]/20 text-[#1B3A6B] cursor-pointer hover:bg-[#1B3A6B] hover:text-white transition-colors">
                <i className="ri-kakao-talk-line text-sm" />
              </a>
              <a href="https://youtube.com" target="_blank" rel="nofollow noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded-full border border-[#1B3A6B]/20 text-[#1B3A6B] cursor-pointer hover:bg-[#1B3A6B] hover:text-white transition-colors">
                <i className="ri-youtube-line text-sm" />
              </a>
            </div>
          </div>

          <div>
            <p className="text-[#1B3A6B] text-xs font-bold tracking-widest uppercase mb-4 border-b border-[#1B3A6B]/10 pb-2">지부 소개</p>
            <ul className="space-y-2.5">
              {['인사말', '오시는 길', '본회 안내'].map((item) => (
                <li key={item}>
                  <Link to="/about" className="text-gray-500 text-sm hover:text-[#1B3A6B] transition-colors cursor-pointer">{item}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-[#1B3A6B] text-xs font-bold tracking-widest uppercase mb-4 border-b border-[#1B3A6B]/10 pb-2">수강생 모집</p>
            <ul className="space-y-2.5">
              {['교육과정', '강사진', '수강생 혜택', '상담 신청'].map((item) => (
                <li key={item}>
                  <Link to="/academy" className="text-gray-500 text-sm hover:text-[#1B3A6B] transition-colors cursor-pointer">{item}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-[#1B3A6B] text-xs font-bold tracking-widest uppercase mb-4 border-b border-[#1B3A6B]/10 pb-2">고객지원</p>
            <ul className="space-y-2.5">
              {['자격증 안내', '위생교육', '공지사항', 'FAQ'].map((item) => (
                <li key={item}>
                  <Link to="/community" className="text-gray-500 text-sm hover:text-[#1B3A6B] transition-colors cursor-pointer">{item}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8">
          <div className="bg-white rounded-lg px-6 py-5 mb-6 border border-gray-100">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div>
                <p className="text-gray-600 text-xs leading-relaxed">
                  <strong className="text-gray-800">주소:</strong> 서울 중구 명동3길 5 위드빌딩 6층<br />
                  <strong className="text-gray-800">대표전화:</strong> 010-6740-4061 &nbsp;|&nbsp;
                  <strong className="text-gray-800">이메일:</strong> a01067404061@gmail.com
                </p>
              </div>
              <div className="md:text-right">
                <p className="text-gray-600 text-xs leading-relaxed">
                  <strong className="text-gray-800">사업자등록번호:</strong> 335-71-00681 &nbsp;|&nbsp;
                  <strong className="text-gray-800">대표자:</strong> 김병희<br />
                  <strong className="text-gray-800">운영시간:</strong> 평일 09:00~18:00 / 토 10:00~15:00
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-gray-400 text-xs">© 2026 대한문신사중앙회 중구지부. All rights reserved.</p>
            <div className="flex gap-4">
              <a href="#" className="text-gray-400 text-xs hover:text-gray-600 cursor-pointer">개인정보처리방침</a>
              <a href="#" className="text-gray-400 text-xs hover:text-gray-600 cursor-pointer">이용약관</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
